var _defs, _polygon, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSymbolpack5Solid25({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "a",
    points: "7.78 0.75 0.28 15.24 15.28 15.24 7.78 0.75"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.24,10A3.5,3.5,0,0,1,5.5,8.49,2.67,2.67,0,0,1,6,7.7a2.24,2.24,0,0,1,.74-.51A3,3,0,0,1,8,7a2.68,2.68,0,0,1,2,.78,3,3,0,0,1,.76,2.19A3,3,0,0,1,10,12.1a2.68,2.68,0,0,1-2,.78,2.69,2.69,0,0,1-2-.78A3,3,0,0,1,5.24,10Zm1.19,0a2.14,2.14,0,0,0,.45,1.47,1.48,1.48,0,0,0,1.14.5,1.41,1.41,0,0,0,1.13-.5A2.16,2.16,0,0,0,9.6,9.9a2.13,2.13,0,0,0-.44-1.47A1.45,1.45,0,0,0,8,8a1.45,1.45,0,0,0-1.15.49A2.11,2.11,0,0,0,6.43,9.92Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSymbolpack5Solid25);
export default __webpack_public_path__ + "static/media/Symbolpack_5_solid_25.ee4ed57a5699055b91add37aefc2fd08.svg";
export { ForwardRef as ReactComponent };